import React, { lazy } from "react";
import { useState, useEffect } from "react";
import { useLocale } from "../context/LocaleContext";
import { useRedirection } from "../context/RedirectionContext";
import { Grid, Stack, Collapse, Pagination, Box, Typography } from "@mui/material";
import AdvancedFilter from "../components/Filters/AdvancedFilter";
import InventoryItem from "../components/Inventory/InventoryItem";
import { TransitionGroup } from "react-transition-group";
import { CustomChip, CustomChipSelected, config } from "../components/Inventory/CustomChips";
import CustomButton from "../components/Base/CustomButton";
import InventoryItemLoader from "../components/Inventory/InventoryItemLoader";
import SearchBar from "../components/SearchBar";
import CategoySelector from "../components/Inventory/CategorySelector";

import useInventoryStorage from "../hooks/useInventoryStorage";

const PAGESIZE = 20;

export default function InventoryPage() {
	const { redirectionData, setRedirection } = useRedirection();
	const { messages } = useLocale();
	const [risks, setRisks] = useState([]);
	const [loaded, setLoaded] = useState(false);
	const [renderedData, setRenderedData] = useState();
	const [expanded, setExpanded] = useState();
	const [search, setSearch] = useState('');
	const [category, setCategory] = useState('');
	const [inventory, setInventory] = useState([]);
	const [page, setPage] = useState(1);
	// const [inventory, dispatch] = useInventoryStorage("inventory", []);

	const redirectionSearch = (risk, page = 1) => {
		const getData = async () => {
			const response = await fetch(
				`${process.env.REACT_APP_BACKEND_URL}/stocks/search_inventory/MUM1957MH/?` + [
					`page=${page}`,
					`page_size=${PAGESIZE}`,
					search !== '' ? `text=${search}` : null,
					category !== '' ? `item_category=${category}` : null,
					risk.filter(r => r !== 'ok').map(r => `${r}=True`).join('&'),
				].filter(e => e).join('&'),
				{
					method: "GET",
					headers: {
						"Content-Type": "appliation/json",
					},
				}
			)
			if (response.ok) {
				const d = await response.json();
				if (d.status === "success") {
					const data = d.data.map(x => { return { ...x, risk: x.quantity < x.understock_qt ? 'understock' : x.quantity > x.overstock_qt ? 'overstock' : 'ok' } })
					console.log(data);
					setInventory(data);
					setRenderedData(data);
				}
				else {
					setRenderedData([]);
				}
				console.log(d);
			}
		}
		getData();
		setRedirection({});
	}

	const voiceSearch = (searchStr, page = 1) => {
		const getData = async () => {
			const response = await fetch(
				`${process.env.REACT_APP_BACKEND_URL}/stocks/search_inventory/MUM1957MH/?` + [
					`page=${page}`,
					`page_size=${PAGESIZE}`,
					searchStr !== '' ? `text=${searchStr}` : null,
					category !== '' ? `item_category=${category}` : null,
					risks.filter(r => r !== 'ok').map(r => `${r}=True`).join('&'),
					'audio=true',
				].filter(e => e).join('&'),
				{
					method: "GET",
					headers: {
						"Content-Type": "appliation/json",
					},
				}
			)
			if (response.ok) {
				const d = await response.json();
				if (d.status === "success") {
					const data = d.data.map(x => { return { ...x, risk: x.quantity < x.understock_qt ? 'understock' : x.quantity > x.overstock_qt ? 'overstock' : 'ok' } })
					console.log(data);
					setInventory(data);
					setRenderedData(data);
				}
				else {
					setRenderedData([]);
				}
				console.log(d);
			}
		}
		getData();
		setRedirection({});
	}

	const doApiSearch = (page = 1) => {
		console.log(search);
		const getData = async () => {
			const response = await fetch(
				`${process.env.REACT_APP_BACKEND_URL}/stocks/search_inventory/MUM1957MH/?` + [
					`page=${page}`,
					`page_size=${PAGESIZE}`,
					search !== '' ? `text=${search}` : null,
					category !== '' ? `item_category=${category}` : null,
					risks.filter(r => r !== 'ok').map(r => `${r}=True`).join('&'),
				].filter(e => e).join('&'),
				{
					method: "GET",
					headers: {
						"Content-Type": "appliation/json",
					},
				}
			)
			if (response.ok) {
				const d = await response.json();
				if (d.status === "success") {
					const data = d.data.map(x => { return { ...x, risk: x.quantity < x.understock_qt ? 'understock' : x.quantity > x.overstock_qt ? 'overstock' : 'ok' } })
					console.log(data);
					setInventory(data);
					setRenderedData(data);
				}
				else {
					setRenderedData([]);
				}
				console.log(d);
			}
		}
		getData();
		setRedirection({});
	}

	const handleRiskChange = (newRisk) => {
		if (risks.includes(newRisk)) {
			setRisks((prevRisks) => [...prevRisks].filter(risk => risk !== newRisk));
		}
		else {
			setRisks((prevRisks) => [...prevRisks, newRisk]);
		}
	}

	const handlePageChange = (event, value) => {
		setPage(value);
		doApiSearch(risks, value);
	};

	useEffect(() => {
		setLoaded(false);
		const getData = async () => {
			try {
				const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/stocks/view_inventory/MUM1957MH/?page=1&page_size=${PAGESIZE}`, {
					method: "GET",
					headers: {
						"Content-Type": "appliation/json",
					},
				})
				if (response.ok) {
					const d = await response.json();
					if (d.status === "success") {
						const data = d.data.map(x => { return { ...x, risk: x.quantity < x.understock_qt ? 'understock' : x.quantity > x.overstock_qt ? 'overstock' : 'ok' } })
						setInventory(data);
						setRenderedData(data);
					}
					console.log(d);
				}
			}
			catch (e) {
				console.log(e);
				setInventory([]);
				setRenderedData([]);
			}
		}
		console.log(redirectionData);
		if (redirectionData && redirectionData.path === "/inventory") {
			console.log(redirectionData.data.filters);
			setRisks(redirectionData.data.filters);
			redirectionSearch(redirectionData.data.filters);
		}
		else {
			console.log('here');
			getData();
		}
		setLoaded(true);
	}, [])

	useEffect(() => {
		if (redirectionData && redirectionData.path === "/inventory" && loaded) {
			console.log(redirectionData.data.filters);
			setRisks(redirectionData.data.filters);
			redirectionSearch(redirectionData.data.filters);
		}
	}, [redirectionData, loaded])

	// useEffect(() => {
	// 	if (loaded) {
	// 		const filteredData = inventory.filter(item => item.item_name?.toLowerCase().includes(search.toLowerCase())).filter(item => category === "" ? true : item.item_caterogy === category).filter(items => risks.length > 0 ? risks.includes(items.risk) : true);
	// 		console.log(filteredData);
	// 		setRenderedData(filteredData);
	// 	}
	// }, [loaded, risks, search, inventory, category]);

	return (
		<>
			<SearchBar searchString={search} setSearchString={setSearch} placeholder={messages.inventory.search.placeholder} doApiSearch={() => doApiSearch()} voiceSearch={(search) => voiceSearch(search)} />
			<AdvancedFilter>
				<Grid container rowGap={2} mb={4}>
					<Grid item xs={12} md={6}>
						<Stack justifyContent='space-evenly' flexDirection='row' flexWrap='wrap'>
							{Object.keys(config).filter(c => c !== "ok").map((risk, i) => (
								React.cloneElement(risks.includes(risk) ? <CustomChip /> : <CustomChipSelected />, { ...config[risk], label: messages.inventory.chips[risk], onClick: () => handleRiskChange(risk), key: i })
							))}
						</Stack>
					</Grid>
					{/* <Grid item >
						<CategoySelector category={category} setCategory={setCategory}/>
					</Grid> */}
					<Grid item xs={12} md={6} p="5px">
						<CustomButton fullWidth onClick={() => doApiSearch()}>{messages.common.submit}</CustomButton>
					</Grid>
				</Grid>
			</AdvancedFilter>
			<TransitionGroup>
				{loaded ?
					(renderedData?.length !== 0 ?
						renderedData?.map(e => (
							<Collapse key={e.item_id}>
								<InventoryItem {...e} risk={e.risk} setExpanded={() => setExpanded(expanded === e.item_id ? null : e.item_id)} expanded={expanded === e.item_id} />
							</Collapse>
						))
						:
						<Typography fullWidth textAlign="center" variant="h5" style={{ marginTop: '20px'}}>Data Not Found</Typography>
					)
					:

					Array.from({ length: 20 }, (e, i) =>
						<Collapse key={i}>
							<InventoryItemLoader />
						</Collapse>
					)
				}
			</TransitionGroup>
			{renderedData?.length !== 0 &&
				<Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginBottom: "10px" }}>
					<Pagination
						siblingCount={0}
						boundaryCount={1}
						count={10}
						page={page}
						onChange={handlePageChange}
					/>
				</Box>
			}
		</>
	)
}